import { createAction, props } from '@ngrx/store';
import { CreateProjectDto, ProjectDto } from '../../models/project.model';

// Load all projects
export const loadProjects = createAction('[Project] Load Projects');
export const loadProjectsSuccess = createAction(
  '[Project] Load Projects Success',
  props<{ projects: ProjectDto[] }>(),
);
export const loadProjectsError = createAction(
  '[Project] Load Projects Error',
  props<{ error: any }>(),
);

// Load project by ID
export const loadProjectById = createAction(
  '[Project] Load Project by Id',
  props<{ projectId: string }>(),
);
export const loadProjectByIdSuccess = createAction(
  '[Project] Load Project by Id Success',
  props<{ project: ProjectDto }>(),
);
export const loadProjectByIdError = createAction(
  '[Project] Load Project by Id Error',
  props<{ error: any }>(),
);

// Create a new project
export const createProject = createAction(
  '[Project] Create Project',
  props<{ project: CreateProjectDto }>(),
);
export const createProjectSuccess = createAction(
  '[Project] Create Project Success',
  props<{ project: ProjectDto }>(),
);
export const createProjectError = createAction(
  '[Project] Create Project Error',
  props<{ error: any }>(),
);

// Update an existing project
export const updateProject = createAction(
  '[Project] Update Project',
  props<{ projectId: string; project: CreateProjectDto }>(),
);
export const updateProjectSuccess = createAction(
  '[Project] Update Project Success',
  props<{ project: ProjectDto }>(),
);
export const updateProjectError = createAction(
  '[Project] Update Project Error',
  props<{ error: any }>(),
);

// Delete a project
export const deleteProject = createAction(
  '[Project] Delete Project',
  props<{ projectId: string }>(),
);
export const deleteProjectSuccess = createAction(
  '[Project] Delete Project Success',
  props<{ projectId: string }>(),
);
export const deleteProjectError = createAction(
  '[Project] Delete Project Error',
  props<{ error: any }>(),
);
